module.exports = __webpack_public_path__ + "img/cart-top-tip.3df663d8.png";